import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Éditeur du site",
    body: [
      "Le site helencia.fr est édité par Helencia Maison, en cours d'immatriculation.",
      "Adresse du siège : Paris, France.",
      "Contact : hello@helencia.fr",
    ],
  },
  {
    heading: "Directrice de la publication",
    body: [
      "La direction de la publication est assurée par la fondatrice de Helencia Maison.",
    ],
  },
  {
    heading: "Hébergement",
    body: [
      "Le site est hébergé sur l'infrastructure cloud Emergent (AWS · MongoDB Atlas · Kubernetes).",
    ],
  },
  {
    heading: "Propriété intellectuelle",
    body: [
      "L'ensemble des éléments constitutifs du site (charte graphique, textes, illustrations, logo, code source) sont la propriété exclusive de Helencia Maison, à l'exception des contenus publiés par les utilisateurs qui demeurent leur propriété.",
      "Toute reproduction, représentation ou diffusion, totale ou partielle, du contenu du site sans autorisation écrite préalable est strictement interdite.",
    ],
  },
  {
    heading: "Crédits photos",
    body: [
      "Les photographies éditoriales présentes sur la page d'accueil sont utilisées à titre illustratif. Les portfolios et images publiés par les talents et professionnels relèvent de leur propriété intellectuelle respective.",
    ],
  },
  {
    heading: "Contact juridique",
    body: [
      "Pour toute question d'ordre juridique ou signalement : legal@helencia.fr",
    ],
  },
];

export default function Mentions() {
  return <LegalPage title="Mentions légales" sections={SECTIONS} testid="mentions-page" />;
}
